import { postAddToCart } from '~js/utils/variant';

const addToBagButtons = document.querySelectorAll('[data-quick-add-to-bag]');
const stickyBtn = document.querySelector(
  '.js-buybox__product-addToCartStickyBtn',
);
export function handleQuickBuyClickGlobal() {
  addToBagButtons?.forEach((btn) =>
    btn.addEventListener('click', handleQuickBuyClick),
  );

  function handleQuickBuyClick(event) {
    const handle = event.currentTarget.dataset.handle;

    const isSticky = event.currentTarget === stickyBtn;
    const dataId = event.currentTarget.dataset.id;
    const productClickedInPdp = window.location.pathname.includes('/products/');
    if (dataId) {
      postAddToCart(dataId);
    } else {
      if (window.innerWidth > 1024) {
        window.QuickBuy.trigger(handle, false, isSticky, productClickedInPdp);
      } else {
        window.QuickBuyMobile?.trigger(handle, isSticky);
      }
    }
  }
}
